import { SyncRouteComponent } from "@/components/Search/SearchResults/components/SyncRoute/syncRoute.component";
import { useSearchResultsContext } from "@/components/Search/SearchResults/context/searchResults.context";
import { useIsClientSide } from "@/utils/hooks/isClient.hook";

export const SyncRoute = () => {
    const { algoliaSearchParameters } = useSearchResultsContext();

    const isClientSide = useIsClientSide();

    if (!isClientSide) return null;

    return (
        <SyncRouteComponent ignoreQuery={!!algoliaSearchParameters?.query} />
    );
};
